export enum UserType {
    resident = 'resident',
    super_admin = 'super_admin',
    property_manager = 'property_manager',
    staff = 'staff',
    vendor = 'vendor',
}



// WEBPACK FOOTER //
// /app/src/app/types/api-response/auth/user-type.ts